<script>
  export let group = undefined;
  export let value;
  export let label;
</script>

<label class="radio" for="radio-{value}-{label}">
  <input
    type="checkbox"
    class="radio__input-hidden"
    checked={group === value}
    {value}
    on:click={(event) =>
      group === value ? event.preventDefault() : (group = value)}
  />
  <span class="radio__input-custom radio__input-custom--{value}" />
  <span class="radio__label">{value}</span>
  {#if value < 10}
    <span class="radio__1-10-line radio__1-10-line--{value}" />
  {/if}
</label>
